import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const IceCream = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='IceCream' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M17,8 C19,8 19,6.5 17.5,6.5 C17.5,3.5 15.5,1 12,1 C8.5,1 6.5,3.5 6.5,6.5 C5,6.5 5,8 7,8 M7,8 L17,8 L12,21 L7,8 Z' />
  </StyledIcon>
);
